import { Container } from "inversify";
import { TokenContainerModule } from "inversify-token";
import { YinzCamInjectModule } from "yinzcam-inject";
import { CardsLibraryRecord, CardsLibraryToken } from "../common/CardsLibraryToken";

import * as UnknownCard from "./UnknownCard/UnknownCard.svelte";
import * as PlaceholderCard from "./PlaceholderCard/PlaceholderCard.svelte";
import * as AdSlot from "./AdSlot/AdSlot.svelte";
import * as HTML from "./HTML/HTML.svelte";
import * as SectionHeading from "./SectionHeading/SectionHeading.svelte";
import * as SimpleCard from "./SimpleCard/SimpleCard.svelte";

// SSO22
import * as SSO22__AccountRegisterButton from './SSO22/AccountRegisterButton/AccountRegisterButton.svelte';
import * as SSO22__GenericAccountRegisterButton from './SSO22/GenericAccountRegisterButton/GenericAccountRegisterButton.svelte';
import * as SSO22__ProfileSaveButton from './SSO22/ProfileSaveButton/ProfileSaveButton.svelte';
import * as SSO22__ResetPasswordStartButton from './SSO22/ResetPasswordStartButton/ResetPasswordStartButton.svelte';
import * as SSO22__OpenEmailAppButton from './SSO22/OpenEmailAppButton/OpenEmailAppButton.svelte';
import * as SSO22__ProfilePhotoSaveButton from './SSO22/ProfilePhotoSaveButton/ProfilePhotoSaveButton.svelte';
import * as SSO22__AccountLogInButton from './SSO22/AccountLogInButton/AccountLogInButton.svelte';
import * as SSO22__ResetPasswordEndButton from './SSO22/ResetPasswordEndButton/ResetPasswordEndButton.svelte';
import * as SSO22__NameInputField from './SSO22/NameInputField/NameInputField.svelte';
import * as SSO22__EmailInputField from './SSO22/EmailInputField/EmailInputField.svelte';
import * as SSO22__PhoneNumberInputField from './SSO22/PhoneNumberInputField/PhoneNumberInputField.svelte';
import * as SSO22__BirthDateInputField from './SSO22/BirthDateInputField/BirthDateInputField.svelte';
import * as SSO22__UsernameInputField from './SSO22/UsernameInputField/UsernameInputField.svelte';
import * as SSO22__AddressInputField from './SSO22/AddressInputField/AddressInputField.svelte';
import * as SSO22__OptInCheckbox from './SSO22/OptInCheckbox/OptInCheckbox.svelte';
import * as SSO22__RememberMeCheckbox from './SSO22/RememberMeCheckbox/RememberMeCheckbox.svelte';
import * as SSO22__UserProfileHeader from './SSO22/UserProfileHeader/UserProfileHeader.svelte';
import * as SSO22__LinkCompleteHeader from './SSO22/LinkCompleteHeader/LinkCompleteHeader.svelte';
import * as SSO22__LinkTicketmasterAccount from './SSO22/LinkTicketmasterAccount/LinkTicketmasterAccount.svelte';
import * as SSO22__LinkGoogleAccount from './SSO22/LinkGoogleAccount/LinkGoogleAccount.svelte';
import * as SSO22__LinkAppleAccount from './SSO22/LinkAppleAccount/LinkAppleAccount.svelte';
import * as SSO22__LinkSeatGeekAccount from './SSO22/LinkSeatGeekAccount/LinkSeatGeekAccount.svelte';
import * as SSO22__LinkFacebookAccount from './SSO22/LinkFacebookAccount/LinkFacebookAccount.svelte';
import * as SSO22__LinkClearAccount from './SSO22/LinkClearAccount/LinkClearAccount.svelte';
import * as SSO22__LinkAXSAccount from './SSO22/LinkAXSAccount/LinkAXSAccount.svelte';
import * as SSO22__LinkNFLIDAccount from './SSO22/LinkNFLIDAccount/LinkNFLIDAccount.svelte';
import * as SSO22__LearnMore from './SSO22/LearnMore/LearnMore.svelte';
import * as SSO22__PasswordInputField from './SSO22/PasswordInputField/PasswordInputField.svelte';
import * as SSO22__NavigationButton from './SSO22/NavigationButton/NavigationButton.svelte';
import * as SSO22__ResetPasswordValidateButton from './SSO22/ResetPasswordValidateButton/ResetPasswordValidateButton.svelte';
import * as SSO22__PinInputField from './SSO22/PinInputField/PinInputField.svelte';
import * as SSO22__DisconnectAccount from "./SSO22/DisconnectAccount/DisconnectAccount.svelte";
import * as SSO22__LoginWithAppleAccount from "./SSO22/LoginWithAppleAccount/LoginWithAppleAccount.svelte";
import * as SSO22__LoginWithGoogleAccount from "./SSO22/LoginWithGoogleAccount/LoginWithGoogleAccount.svelte";
import * as SSO22__LoginWithFacebookAccount from "./SSO22/LoginWithFacebookAccount/LoginWithFacebookAccount.svelte";
import * as SSO22__LoginWithNFLIDAccountAuto from "./SSO22/LoginWithNFLIDAccountAuto/LoginWithNFLIDAccountAuto.svelte";
import * as SSO22__LoginWithPingAccountAuto from "./SSO22/LoginWithPingAccountAuto/LoginWithPingAccountAuto.svelte";
import * as SSO22__LoginWithTunespeakAccountAuto from "./SSO22/LoginWithTunespeakAccountAuto/LoginWithTunespeakAccountAuto.svelte";
import * as SSO22__LoginWithEnactorAccountAuto from "./SSO22/LoginWithEnactorAccountAuto/LoginWithEnactorAccountAuto.svelte";
import * as SSO22__GenericProfileSaveButton from './SSO22/GenericProfileSaveButton/GenericProfileSaveButton.svelte';
import * as Seahawks__ForcedUpdate from './Seahawks/ForcedUpdate/ForcedUpdate.svelte';
import * as SSO22__UnlockButton from "./SSO22/UnlockButton/UnlockButton.svelte";
import * as SSO22__SubscriptionSigninButton from "./SSO22/SubscriptionSigninButton/SubscriptionSigninButton.svelte";
import * as SSO22__SubscriptionTerm from "./SSO22/SubscriptionTerm/SubscriptionTerm.svelte";
import * as SSO22__SubscribeWithStripe from "./SSO22/SubscribeWithStripe/SubscribeWithStripe.svelte";
import * as SSO22__GenericTextInputField from './SSO22/GenericTextInputField/GenericTextInputField.svelte';
import * as SSO22__GenericSelectInputField from './SSO22/GenericSelectInputField/GenericSelectInputField.svelte';
import * as SSO22__LoginWithNBAIDAccountAuto from './SSO22/LoginWithNBAIDAccountAuto/LoginWithNBAIDAccountAuto.svelte';
import * as SSO22__LoginWithCognitoOIDCAccountAuto from './SSO22/LoginWithCognitoOIDCAccountAuto/LoginWithCognitoOIDCAccountAuto.svelte';
import * as SSO22__LoginWithKOREBrandedUIAuto from './SSO22/LoginWithKOREBrandedUIAuto/LoginWithKOREBrandedUIAuto.svelte';
import * as SSO22__LoginWithSeatGeekAccount from './SSO22/LoginWithSeatGeekAccount/LoginWithSeatGeekAccount.svelte';
import * as SSO22__LoginWithSeatGeekAccountAuto from './SSO22/LoginWithSeatGeekAccountAuto/LoginWithSeatGeekAccountAuto.svelte';
import * as SSO22__ProfileWithKOREBrandedUIAuto from './SSO22/ProfileWithKOREBrandedUIAuto/ProfileWithKOREBrandedUIAuto.svelte';
import * as SSO22__LoginWithFMFFanKeyAccountAuto from './SSO22/LoginWithFMFFanKeyAccountAuto/LoginWithFMFFanKeyAccountAuto.svelte';
import * as SSO22__LoginWithTicketmasterAccount from './SSO22/LoginWithTicketmasterAccount/LoginWithTicketmasterAccount.svelte';
import * as SSO22__LoginWithTicketmasterAccountAuto from './SSO22/LoginWithTicketmasterAccountAuto/LoginWithTicketmasterAccountAuto.svelte';
import * as SSO22__LoginWithKOREOpenIDAccountAuto from './SSO22/LoginWithKOREOpenIDAccountAuto/LoginWithKOREOpenIDAccountAuto.svelte';
import * as SSO22__LoginWithAuth0OIDCAccountAuto from './SSO22/LoginWithAuth0OIDCAccountAuto/LoginWithAuth0OIDCAccountAuto.svelte';

import _ from "lodash";

const CARD_LIBRARY: { [ key: string ]: CardsLibraryRecord } = {
  UnknownCard,
  PlaceholderCard,
  AdSlot,
  HTML,
  SectionHeading,
  SimpleCard,
  SSO22__AccountRegisterButton,
  SSO22__GenericAccountRegisterButton,
  SSO22__ProfileSaveButton,
  SSO22__ResetPasswordStartButton,
  SSO22__OpenEmailAppButton,
  SSO22__ProfilePhotoSaveButton,
  SSO22__AccountLogInButton,
  SSO22__ResetPasswordEndButton,
  SSO22__NameInputField,
  SSO22__EmailInputField,
  SSO22__PhoneNumberInputField,
  SSO22__BirthDateInputField,
  SSO22__UsernameInputField,
  SSO22__AddressInputField,
  SSO22__OptInCheckbox,
  SSO22__RememberMeCheckbox,
  SSO22__UserProfileHeader,
  SSO22__LinkCompleteHeader,
  SSO22__LinkTicketmasterAccount,
  SSO22__LinkAppleAccount,
  SSO22__LinkFacebookAccount,
  SSO22__LinkGoogleAccount,
  SSO22__LinkSeatGeekAccount,
  SSO22__LinkClearAccount,
  SSO22__LinkAXSAccount,
  SSO22__LinkNFLIDAccount,
  SSO22__LoginWithCognitoOIDCAccountAuto,
  SSO22__LearnMore,
  SSO22__PasswordInputField,
  SSO22__NavigationButton,
  SSO22__ResetPasswordValidateButton,
  SSO22__PinInputField,
  SSO22__DisconnectAccount,
  SSO22__LoginWithAppleAccount,
  SSO22__LoginWithGoogleAccount,
  SSO22__LoginWithFacebookAccount,
  SSO22__LoginWithNFLIDAccountAuto,
  SSO22__LoginWithPingAccountAuto,
  SSO22__LoginWithTunespeakAccountAuto,
  SSO22__LoginWithEnactorAccountAuto,
  SSO22__GenericProfileSaveButton,
  SSO22__GenericTextInputField,
  SSO22__GenericSelectInputField,
  Seahawks__ForcedUpdate,
  SSO22__UnlockButton,
  SSO22__SubscriptionSigninButton,
  SSO22__SubscriptionTerm,
  SSO22__SubscribeWithStripe,
  SSO22__LoginWithNBAIDAccountAuto,
  SSO22__LoginWithKOREBrandedUIAuto,
  SSO22__LoginWithSeatGeekAccount,
  SSO22__LoginWithSeatGeekAccountAuto,
  SSO22__ProfileWithKOREBrandedUIAuto,
  SSO22__LoginWithFMFFanKeyAccountAuto,
  SSO22__LoginWithTicketmasterAccount,
  SSO22__LoginWithTicketmasterAccountAuto,
  SSO22__LoginWithKOREOpenIDAccountAuto,
  SSO22__LoginWithAuth0OIDCAccountAuto,
};

export const CardsLibraryModule: YinzCamInjectModule = new YinzCamInjectModule((container: Container): void => {
  container.load(new TokenContainerModule((bindToken) => {
    for (let k in CARD_LIBRARY) {
      const clazz = k.replace(/__/g, '.');
      const rec = CARD_LIBRARY[k];
      rec.clazz = clazz;
      let filtered = false;
      if (!_.isNil(CONFIG.cardClassFilters) && clazz !== 'PlaceholderCard' && clazz !== 'UnknownCard') {
        filtered = true;
        for (let filterKey in CONFIG.cardClassFilters) {
          const filter = CONFIG.cardClassFilters[filterKey];
          if ((filter.slice(-1) === '*' && clazz.startsWith(filter.slice(0, -2))) || clazz === filter) {
            filtered = false;
            break;
          }
        }
      }
      if (!filtered) {
        bindToken(CardsLibraryToken).toConstantValue(rec).whenTargetNamed(clazz);
      }
    }
  }));
});
